export interface RedirectLocation {
  pathname: string;
  search: string;
  hash: string;
}

/** Builds a safe local sign-in URL while retaining the original destination. */
export function signInRedirect(location: RedirectLocation): string {
  const next = `${location.pathname}${location.search}${location.hash}`;
  return next === '/' ? '/signin' : `/signin?next=${encodeURIComponent(next)}`;
}
